import actions from './actions'
import getters from './getters'
import { LabelsState } from './types'
import { Module } from 'vuex'
import mutations from './mutations'
import { TRootState } from '../types'
import state from './state'

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state
} as Module<LabelsState, TRootState>
